<template>
  <b-modal id="create_contact_login_modal" ref="create_contact_login_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1>
          <i class="fas fa-user-plus"></i>
          <span>Create Contact Login</span>
        </h1>
      </div>
      <button id="mh-close" class="btn-close" v-on:click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="createUserForm" slim>
      <form role="form" @submit.prevent="create_user_submit">
        <div class="row" v-if="notEmptyObject(contact)">
          <div class="col-12"><h3 class="bp_color font-weight-bold mb-0">{{ contact.person.first_name }} {{ contact.person.surname }}</h3></div>
          <div class="col-12"><h5 class="mb-0" v-if="contact.rel_profile.job_title_id !== null">{{ contact.rel_profile.job_title.job_title }}</h5></div>
          <div class="col-12">
            <hr>
          </div>

          <div class="col-6 form-group">
            <ValidationProvider rules="required" v-slot="{errors, classes}" name="Mobile Number" tag="div">
              <label class="form-label" for="mobile">Mobile Number</label>
              <input type="text" v-model="mobile" id="mobile" name="mobile" class="form-input disabled" :class="classes" readonly>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group">
            <ValidationProvider rules="email|required" v-slot="{errors, classes}" name="Email Address" tag="div">
              <label class="form-label" for="email">Email Address</label>
              <input type="email" v-model="email" id="email" class="form-input disabled" :class="classes" readonly>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="col-6 form-group">
            <ValidationProvider rules="required|min:6|verify_password|password:@Confirmation" name="Password" v-slot="{ errors, classes }">
              <label class="form-label" for="password">Password</label>
              <input type="text" v-model="password" id="password" name="password" class="form-input" :class="classes" autocomplete="off"/>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <div class="col-6 form-group">
            <ValidationProvider rules="required|password:@Password" name="Confirmation" v-slot="{ errors, classes }">
              <label class="form-label" for="confirmation">Confirmation</label>
              <input type="text" v-model="confirmation" id="confirmation" name="confirmation" class="form-input" :class="classes" autocomplete="off"/>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="col-6">
            <button @click.prevent="edit_contact" class="btn orcaBtn blueBtn">Edit Contact</button>
          </div>
          <div class="col-6">
            <button type="submit" class="btn orcaBtn">Create Contact Login</button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
export default {
  name: "create_contact_login",
  data() {
    return {
      password: '',
      confirmation: '',

      contact: this.$store.state.timesheets.create_login_contact,
    }
  },
  computed: {
    client_role() {
      if (this.$store.state.timesheets.create_login_contact_level <= 7) {
        return 'client_auth';
      }
      if (this.$store.state.timesheets.create_login_contact_level >= 8) {
        return 'client_sub';
      }
    },
    mobile() {
      if (this.contact.rel_phones !== null) {
        let phone = this.contact.rel_phones.find(rp => rp.phone_type_id === 57);
        if (phone !== undefined) {
          return phone.phone_number;
        }
        else {
          return null
        }
      }
      else {
        return null;
      }
    },
    email() {
      if (this.contact.rel_emails !== null) {
        let email = this.contact.rel_emails.find(rp => rp.email_type_id === 63);
        if (email !== undefined) {
          return email.email_address;
        }
        else {
          return null
        }
      }
      else {
        return null;
      }
    }
  },

  methods: {
    hideModal() {
      this.$refs.create_contact_login_modal.hide();
      this.$store.commit('HIDE_CONTACT_LOGIN_MODALS');
    },
    edit_contact() {
      this.hideModal();
      this.$store.commit('SHOW_EDIT_CONTACT_MODAL', {
        contact_id: this.contact.id,
        company_id: this.contact.company_id,
      });
      this.$nextTick(() => this.$root.$emit('bv::show::modal', 'edit_contact_modal'))
    },
    create_user_submit() {
      this.$refs.createUserForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.createUserForm);
        }
        else {
          let create_user = {
            first_name: this.contact.person.first_name,
            surname: this.contact.person.surname,
            email: this.email,
            password: this.password,
            password_confirmation: this.confirmation,
            contact_id: this.contact.id,
            active: true,
            remote_access: true,
            client_role: this.client_role
          };

          axios.post(this.crmApiPath + 'user/contact/create', create_user).then(() => {
            this.hideModal();
            this.$snotify.success(this.contact.full_name + ' : Login Created ');
            this.$nextTick(() => {
              this.$bus.$emit('default_company_ts_auth::reload', {action: true});
              this.$bus.$emit('contacts::reload', {type: 'contact', action: true});
            })
          })
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
#create_contact_login_modal {
  #mh-info {
    span {
      display:     block;
      width:       100%;
      line-height: 0.9rem;
    }
  }
}
</style>
